// extracted by mini-css-extract-plugin
module.exports = {"uppercase":"Link_uppercase__1Jm8V"};